/* Bluebells - make chosen filter groups behave like radios.
   Shopify renders metafield filters as checkboxes; this unticks the
   other values in the same group before the facets script reads the
   form, so only one band can be active at a time. */
(function () {
  'use strict';

  var SINGLE_SELECT = ['filter.p.m.custom.price_band', 'filter.p.m.custom.location_and_lead_time'];

  function isSingleSelect(name) {
    for (var i = 0; i < SINGLE_SELECT.length; i++) {
      if (name === SINGLE_SELECT[i] || name.indexOf(SINGLE_SELECT[i]) === 0) return true;
    }
    return false;
  }

  /* Capture phase, so this runs before the theme's own change handler. */
  document.addEventListener('change', function (ev) {
    var t = ev.target;
    if (!t || t.type !== 'checkbox' || !t.name || !t.checked) return;
    if (!isSingleSelect(t.name)) return;

    var scope = t.form || document;
    var boxes = scope.querySelectorAll('input[type="checkbox"]');
    for (var i = 0; i < boxes.length; i++) {
      if (boxes[i] !== t && boxes[i].name === t.name && boxes[i].checked) {
        boxes[i].checked = false;
      }
    }
  }, true);
}());

/* ---- Tooltip on the "Location and lead time" filter heading ---- */
(function () {
  var MATCH = 'location and lead time';
  var TEXT = 'Denotes the minimum notice required';

  function styles() {
    if (document.getElementById('bb-tip-styles')) return;
    var s = document.createElement('style');
    s.id = 'bb-tip-styles';
    s.textContent =
      '.bb-tip-wrap{position:relative}' +
      '.bb-tip{display:inline-flex;align-items:center;justify-content:center;' +
      'width:16px;height:16px;margin:0 0 0 8px;padding:0;border-radius:50%;' +
      'border:1px solid #262967;background:transparent;color:#262967;' +
      'font-size:11px;font-weight:600;line-height:1;cursor:pointer;' +
      'vertical-align:middle;position:relative;top:-2px}' +
      '.bb-tip__bubble{position:absolute;top:calc(100% + 6px);left:0;width:100%;' +
      'max-width:300px;box-sizing:border-box;padding:8px 10px;border-radius:6px;' +
      'background:#262967;color:#fff;font-size:12px;line-height:1.4;font-weight:400;' +
      'text-align:left;text-transform:none;letter-spacing:0;white-space:normal;' +
      'opacity:0;visibility:hidden;transition:opacity .15s ease;z-index:30;pointer-events:none}' +
            '.bb-tip-wrap.is-open .bb-tip__bubble,' +
      '.bb-tip:hover ~ .bb-tip__bubble,' +
      '.bb-tip-wrap:has(.bb-tip:hover) .bb-tip__bubble{opacity:1;visibility:visible}';
    document.head.appendChild(s);
  }

  function host(el) {
    var kids = el.querySelectorAll('*'), best = null;
    for (var i = 0; i < kids.length; i++) {
      var t = (kids[i].textContent || '').trim().toLowerCase();
      if (t.indexOf(MATCH) !== 0) continue;
      if (!best || kids[i].textContent.length < best.textContent.length) best = kids[i];
    }
    return best || el;
  }

  function build() {
    styles();
    var els = document.querySelectorAll('summary, .facets__heading, .facets__summary, legend');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if ((el.textContent || '').trim().toLowerCase().indexOf(MATCH) !== 0) continue;
      if (el.querySelector('.bb-tip')) continue;

      el.classList.add('bb-tip-wrap');

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bb-tip';
      btn.setAttribute('aria-label', TEXT);
      btn.textContent = 'i';
      btn.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        var w = this.closest('.bb-tip-wrap');
        if (w) w.classList.toggle('is-open');
      });

      var bubble = document.createElement('span');
      bubble.className = 'bb-tip__bubble';
      bubble.textContent = TEXT;

      host(el).appendChild(btn);
      el.appendChild(bubble);
    }
  }

  document.addEventListener('DOMContentLoaded', build);
  build();
  setInterval(build, 500);
})();